module.exports = __webpack_public_path__ + "static/media/conflictb403c934.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/conflict.svg
// module id = 1321
// module chunks = 0